import { Col, Row } from 'antd';
import React from 'react';

import { IMAGES } from '../../../enum';
import { capitalizeEveryWordOfString, momentTimezone } from '../../../utils/common';
import Button from '../../Button';
import Text from '../../Text';
import classNames from './styles.module.scss';

const BusinessVehicleSummary = props => {
  const { t, vehicle, onEdit, isDeleting, onDelete, onMakeDefault } = props;

  return (
    <Row>
      <Col flex="425px">
        <Row wrap={false} gutter={16} justify="space-between" align="middle">
          <Col flex={1}>
            <div>
              <Text variant="h5">
                {vehicle.model.replace(/^_/, '')}{' '}
                {capitalizeEveryWordOfString(vehicle.make.replace(/^_/, ''))}, {vehicle.year}
              </Text>
            </div>

            <div>
              <Text>
                {t('addedOn__date', {
                  date: momentTimezone(vehicle.created).format('MMM DD, YYYY'),
                })}
              </Text>
            </div>
          </Col>

          <Col flex="140px">
            <img className={classNames.carImage} alt="vehicle" src={IMAGES.CAR_CLOUD_ICON} />
          </Col>
        </Row>
        <Row gutter={10}>
          {typeof onEdit === 'function' && (
            <Col flex={1}>
              <Button block disabled={isDeleting} onClick={onEdit}>
                {t('edit')}
              </Button>
            </Col>
          )}

          {typeof onDelete === 'function' && (
            <Col flex={1}>
              <Button
                block
                type="secondary"
                loading={isDeleting}
                disabled={isDeleting}
                onClick={onDelete}
              >
                {t('delete')}
              </Button>
            </Col>
          )}

          {typeof onMakeDefault === 'function' && (
            <Col flex={1}>
              <Button
                block
                type="primary"
                loading={isDeleting}
                disabled={isDeleting}
                onClick={onMakeDefault}
              >
                {t('makeDefault')}
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default BusinessVehicleSummary;
